module.exports = __webpack_public_path__ + "img/pizza-4.a7e78b93.jpg";